import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import { Table, TableHead, TableCell, TableSortCell } from '../../../components/common/ResponsiveTable'
import Item from './Item'

const useStyles = makeStyles({
  activeCell: { '& span': { fontWeight: 600 } },
})

const SORT_DIRECTION_ICONS = {
  asc: KeyboardArrowUpIcon,
  desc: KeyboardArrowDownIcon,
}

const renderSortIcon = (direction) => () => {
  const Icon = SORT_DIRECTION_ICONS[direction] || UnfoldMoreIcon
  return <Icon fontSize="small" />
}

const COLUMNS = [
  ['name', 'Event Name'],
  ['type', 'Type'],
  ['startAt', 'Start Date'],
  ['endAt', 'End Date'],
  ['location', 'Location'],
  ['status', 'Status'],
]

const List = ({ items, order, onChangeOrder, onDelete, onDuplicate, onEdit }) => {
  const styles = useStyles()
  return (
    <Table
      head={
        <TableHead>
          {COLUMNS.map(([key, label]) => (
            <TableSortCell
              key={key}
              className={order[0] === key ? styles.activeCell : undefined}
              orderLabel={key}
              orderBy={order[0]}
              orderDir={order[1]}
              onChange={onChangeOrder}
              renderIcon={renderSortIcon}
            >
              {label}
            </TableSortCell>
          ))}
          <TableCell />
        </TableHead>
      }
    >
      {items.map((item) => (
        <Item key={item.id} item={item} onDelete={onDelete} onDuplicate={onDuplicate} onEdit={onEdit} />
      ))}
    </Table>
  )
}

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  order: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeOrder: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
}

export default List
